module.exports = __webpack_public_path__ + "img/prev-page.ac580c92.png";